// Drawer.js

import React from 'react'
import './Drawer.css'

const Drawer = ({ isOpen, onClose, children, icon, title }) => {
  return (
    <div className={`drawer ${isOpen ? 'open' : ''}`}>
      <div className="drawer-header">
        <one-ux-icon size="400" icon={icon}></one-ux-icon>

        <div className="drawer-header-text">{title}</div>

        <one-ux-button class="overlay-settings-header-close-button" label="CloseSettings" onClick={onClose} implicit>
          <one-ux-icon icon="close"></one-ux-icon>
        </one-ux-button>
      </div>

      <one-ux-scroll class="drawer-content">
        <div class="drawer-content-container">{children}</div>
      </one-ux-scroll>
    </div>
  )
}

export default Drawer
